import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { Pagination, Response } from '@ui/src';
import { revaluationApi } from './service';
import { Category, Revaluation } from '../types';

export interface RevaluationState {
  accountCategories?: Category[];
  pagination?: Pagination;
  revaluation?: Revaluation[];
  errorsList?: string;
}

const initialState: RevaluationState = {};

export const revaluationSlice = createSlice({
  name: 'statementsList',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addMatcher(
      revaluationApi.endpoints.getRevaluationAccountsCategories.matchFulfilled,
      (state, action: PayloadAction<Response<Category>>) => {
        state.accountCategories = action.payload.data.edges.map(
          (item) => item.node,
        );
      },
    );
    builder.addMatcher(
      revaluationApi.endpoints.getRevalutationList.matchPending,
      (state) => {
        state.errorsList = undefined;
      },
    );
    builder.addMatcher(
      revaluationApi.endpoints.getRevalutationList.matchRejected,
      (state, action: any) => {
        state.revaluation = undefined;
        state.pagination = undefined;

        if (action?.payload.data) {
          if (Array.isArray(action?.payload.data?.message)) {
            state.errorsList = action?.payload.data?.message
              ?.map((item: { value: string }) => item.value)
              .join('; ');
          } else {
            state.errorsList = action?.payload.data?.error;
          }
        }
      },
    );
    builder.addMatcher(
      revaluationApi.endpoints.getRevalutationList.matchFulfilled,
      (state, action: PayloadAction<Response<Revaluation>>) => {
        state.revaluation = action.payload.data.edges.map((item) => item.node);

        state.pagination = action.payload.data.pageInfo;
      },
    );
  },
});

export default revaluationSlice.reducer;
